module.exports = __webpack_public_path__ + "static/financial_access9-9c5cd6e2650aa39b96826bb59e718d5d.png";